import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid';

export const defaultPageSize = 5;
export const defaultStaleTimeMs = 180_000;
export const defaultSortModel: GridSortModel = [];

export type GridDefaults = {
  pageSizeOptions: number[];
  initialPageSize?: number;
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  syncStateToUrl?: boolean;
  noRowsText?: string;
};

export const baseGridDefaults: GridDefaults = {
  pageSizeOptions: [5, 10, 25, 50],
  initialPageSize: defaultPageSize,
  initialSortModel: defaultSortModel,
  initialFilterModel: { items: [] },
  syncStateToUrl: false,
  noRowsText: 'No results found',
};
